export default __webpack_public_path__ + "static/media/metamask.4838a5da.png";